function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-316 -17.79)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H24V24H0Z",
  transform: "translate(316 17.79)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-9272.654 8725.786)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9592.668 -8703.998)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H18.66V18.66H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.71,7.029a2.589,2.589,0,0,0-.886-.6,2.925,2.925,0,0,0-1.135-.21H11.853v6.22h1.788a3.156,3.156,0,0,0,1.174-.21,2.566,2.566,0,0,0,.9-.591,2.624,2.624,0,0,0,.575-.925,3.556,3.556,0,0,0,.2-1.221V9.183a3.556,3.556,0,0,0-.2-1.221,2.717,2.717,0,0,0-.583-.933Zm-.3,2.457a3.4,3.4,0,0,1-.109.879,1.89,1.89,0,0,1-.334.661,1.453,1.453,0,0,1-.552.412,2,2,0,0,1-.77.14h-.708V7.091h.754a1.543,1.543,0,0,1,1.275.536,2.368,2.368,0,0,1,.443,1.547ZM11.853,0,11.34.023,14.3,2.986l1.034-1.034A8.141,8.141,0,0,1,19.97,8.545h1.166A9.312,9.312,0,0,0,11.853,0Z",
  transform: "translate(-2.523 0)",
  fill: "#0096af"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9592.654 -8704.003)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2880.124,10837.928h-1.227a1.3,1.3,0,0,1-1.3-1.269c-.024-.6-.021-1.214-.019-1.8v-7.465a1.392,1.392,0,0,1,.392-1.191,1.393,1.393,0,0,1,1.19-.392l6.834,0v2.4c-.3,0-.622-.009-.942-.009s-.638,0-.942.008h-.021a9.658,9.658,0,0,0-3.045.49c-.633.226-.633.226-.633.874v2.806c0,.116,0,.259.061.3a.838.838,0,0,1,.306.835v3.776C-2879.479,10837.85-2879.587,10837.928-2880.124,10837.928Z",
  transform: "translate(2882.689 -10825.791)",
  fill: "#0096af"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-2876.5,10843.075h-6.166v-.752c0-1.973,3.913-3,6.011-3h.156v3.753Zm-.156-5.26a3.009,3.009,0,0,1-3.007-3,3.009,3.009,0,0,1,3.007-3.007h.156v6a.469.469,0,0,0-.156-.02Z",
  transform: "translate(2884.939 -10827.519)",
  fill: "#0096af"
}))));

var SvgConvertDicomLigthBgd = function SvgConvertDicomLigthBgd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConvertDicomLigthBgd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/convert_dicom_ligth_bgd.b5f84739.svg";
export { ForwardRef as ReactComponent };